<template>
  <div>
    <!-- 导航条过度动画 -->
    <transition-group
      appear
      appear-class="animated fadeIn"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <!-- 不带安装的导航条 -->
      <via-nav-bar
        v-show="!installBarTransfer"
        key="nav_1"
        title="插件详情"
        :blank="false"
        @click-left="$router.$back()"
      >
        <div
          slot="right"
          @click="showMenu=true"
        >
          <van-icon
            class="nav-bar-lright-icon"
            class-prefix="icon"
            name="navicon"
            :size="$vw('25px')"
          />
        </div>
      </via-nav-bar>

      <!-- 带安装的导航条 -->
      <via-nav-bar
        v-show="installBarTransfer"
        key="nav_2"
        :blank="false"
        :border="false"
        class="nav_2"
        style=""
        background="rgba(255, 255, 255, 0)"
        @click-left="$router.$back()"
      >
        <div
          slot="title"
          class="nav-title"
          @click="scrollToTop"
        >
          <!-- <via-plugin-icon
            :icon="plugin.icon"
            :icon-color="plugin.iconColor"
            :icon-bg-color="plugin.iconBgColor"
            :size="30"
          /> -->
        </div>
        <van-button
          slot="right"
          type="primary"
          size="mini"
          round
          :plain="installState === 'uninstall'"
          class="nav-right"
          @click="install(lastVersion)"
        >{{ installText }}</van-button>
      </via-nav-bar>
    </transition-group>

    <!-- 页面内容 -->
    <div
      class="page"
      :style="{ height: $vw(pageHeight) }"
      @scroll="scrollHandle"
    >
      <!-- 用于回到顶部 -->
      <div
        ref="top"
        class="page-top-blank"
      />

      <!-- 插件名字、图标、作者 -->
      <div class="page-top">
        <van-skeleton
          avatar
          :avatar-size="$vw(80)"
          avatar-shape="square"
          :row="4"
          :loading="pageLoading"
        >
          <div class="plugin-info-top">
            <div class="plugin-info-top-left">
              <via-plugin-icon
                class="plugin-icon"
                :icon="plugin.icon"
                :icon-color="plugin.iconColor"
                :icon-bg-color="plugin.iconBgColor"
                :size="80"
              />
            </div>
            <div class="plugin-info-top-right">
              <div class="row plugin-name">{{ plugin.name }}</div>
              <div class="row plugin-author">
                作者: {{ plugin.author && plugin.author.nickname }}
              </div>
              <van-button
                type="primary"
                size="mini"
                :plain="installState === 'uninstall'"
                class="plugin-install-btn"
                @click="install(lastVersion)"
              >{{ installText }}</van-button>
            </div>
          </div>
        </van-skeleton>
      </div>

      <div class="page-bottom">
        <!-- 插件其他信息 -->
        <van-skeleton
          :row="3"
          :loading="pageLoading"
          :style="{ marginTop: $vw('15px') }"
        >
          <div class="plugin-info-title">插件信息</div>
          <div class="plugin-info-bottom">
            <div class="row plugin-introduction">
              <span class="sub-title">简介:</span>
              <span class="sub-content">{{ plugin.introduction }}</span>
            </div>
            <div class="row plugin-version">
              <span class="sub-title">版本:</span>
              <span class="sub-content">{{ lastVersion.version }}</span>
            </div>
            <div class="row plugin-updateTime">
              <span class="sub-title">更新:</span>
              <span class="sub-content">{{ lastVersion.updateTime | timeFormat(2) }}</span>
            </div>
            <div class="row plugin-updateLog">
              <span class="sub-title">日志:</span>
              <span class="sub-content">{{ lastVersion.updateLog }}</span>
            </div>
            <div class="row plugin-supportBrowser">
              <span class="sub-title">适配:</span>
              <span class="sub-content">{{ plugin.supportBrowser && plugin.supportBrowser.join('、') }}</span>
            </div>
          </div>
        </van-skeleton>

        <!-- 插件说明文档 -->
        <van-skeleton
          :style="{ marginTop: $vw('30px') }"
          :row="15"
          :row-width="$vw('345px')"
          :loading="pageLoading"
        >
          <div class="page-bottom-title">插件说明</div>
          <!-- markdown解析器 -->
          <mavon-editor
            class="md md-pink"
            :value="markdown.content"
            :subfield="markdown.subfield"
            :default-open="markdown.defaultOpen"
            :toolbars-flag="markdown.toolbarsFlag"
            :box-shadow="markdown.boxShadow"
            :code-style="markdown.codeStyle"
            :editable="markdown.editable"
            :scroll-style="markdown.scrollStyle"
          />
        </van-skeleton>
      </div>
    </div>

    <!-- 菜单 -->
    <van-action-sheet
      v-model="showMenu"
      :actions="menu"
      cancel-text="取消"
      @select="menuSelectHandle"
      @cancel="showMenu = false"
    />

    <!-- 历史版本 -->
    <van-popup
      v-model="showHistoryVersion"
      position="bottom"
      round
      :style="{ height: $vw(400) }"
    >
      <div
        v-for="version in versions"
        :key="version.id"
        class="version-box"
      >
        <div class="row version-version">版本: {{ version.version }}</div>
        <div class="row version-update-time">更新: {{ version.updateTime | timeFormat }}</div>
        <div class="row version-update-log">日志：{{ version.updateLog }}</div>
        <van-button
          type="primary"
          size="small"
          plain
          class="version-box-intsall-btn"
          @click="install(version)"
        >安装</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Button, Skeleton, ActionSheet, Popup } from 'vant'
import ViaPluginIcon from 'components/common/via-plugin-icon'
import { throttle, PluginCrypto, initDocumentListen, hookAllImageUrl } from '~/utils/func'
import { timeFormat } from '~/utils/filters'
import { Review, UserType } from '~/utils/enum'

export default {
  name: 'PluginDetail',
  inject: ['reload'],
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [ViaPluginIcon.name]: ViaPluginIcon,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup
  },
  filters: {
    timeFormat
  },
  data() {
    return {
      pageLoading: true,
      installBarTransfer: false,
      plugin: {},
      markdown: {
        content: '',
        subfield: false, // 单双栏模式
        defaultOpen: 'preview', // edit： 默认展示编辑区域 ， preview： 默认展示预览区域
        boxShadow: false,
        codeStyle: 'vs2015',
        editable: false,
        toolbarsFlag: false,
        scrollStyle: true
      },
      // 保存scroll的节流函数
      scrollFunc: null,
      timerId: null,
      // 菜单开关
      showMenu: false,
      // 历史版本显示控制
      showHistoryVersion: false,
      // 插件安装状态
      installState: 'install'
    }
  },
  computed: {
    // rpx
    pageHeight() {
      return this.$pxToRpx(this.$clientHeight)
    },
    // 插件安装状态对应
    installText() {
      const state = this.installState
      let text = '安装'
      switch (state) {
        case 'install':
          text = '安装'
          break
        case 'update':
          text = '更新'
          break
        case 'uninstall':
          text = '卸载'
          break
        default:
          break
      }
      return text
    },
    lastVersion() {
      const versions = this.plugin.versions || []
      return versions[0] || {}
    },
    // 菜单选项
    menu() {
      const userId = this.$store.getters['globalData/userInfo'].id
      const myMenu = [
        { name: '查看作者', color: 'var(--light40)', code: 'visitAuthor' },
        { name: '历史版本', color: 'var(--light40)', code: 'historyVersion' },
        { name: '发邮件给作者', color: 'var(--light40)', code: 'concatAuthor' },
        { name: '举报此插件', color: 'var(--light40)', code: 'reportPlugin' }
      ]
      const othersMenu = [
        { name: '查看作者', color: 'var(--light40)', code: 'visitAuthor' },
        { name: '历史版本', color: 'var(--light40)', code: 'historyVersion' },
        { name: '发邮件给作者', color: 'var(--light40)', code: 'concatAuthor' },
        { name: '举报此插件', color: 'var(--light40)', code: 'reportPlugin' }
      ]
      if (this.plugin.author && Number(userId) === Number(this.plugin.author.id)) {
        return myMenu
      }
      return othersMenu
    },
    // 渲染历史版本
    versions() {
      // 页面大小原因，只取4个版本
      let versions = this.plugin.versions || []
      const length = versions.length
      if (length >= 0) {
        versions = versions.slice(1, 5)
        // versions = versions.slice((length >= 5 ? length - 5 : 0), length - 1)
      }
      return versions
    }
  },
  watch: {
    '$route.params.id'(newValue, oldeValue) {
      this.reload()
    }
  },
  mounted() {
    // 初始化监听回调
    initDocumentListen()
    document.addEventListener('click', window.listenDocument, true)
    // 获取插件信息
    this.timerId = setTimeout(() => {
      this.getPluginInfo()
    }, 500)

    // 实例化节流函数并保存
    this.scrollFunc = throttle((e) => {
      const limit = this.$rpxToPx(260)
      const scrollTop = e.target.scrollTop // px
      if (scrollTop > limit) {
        this.installBarTransfer = true
      } else {
        this.installBarTransfer = false
      }
    }, 200)
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
    // 移除监听
    document.removeEventListener('click', window.listenDocument, true)
  },
  updated() {
    hookAllImageUrl(document)
  },
  methods: {
    // 回到顶部
    scrollToTop() {
      const target = this.$refs['top']
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    },
    // 获取插件信息
    getPluginInfo() {
      this.$api.plugin.findById(this.$route.params.id).then(res => {
        if (!this.canRead(res.data.author.id, res.data.reviewState)) {
          this.$router.$replace({
            name: 'NotFound'
          })
        }
        this.plugin = res.data
        this.markdown.content = res.data.doc
        this.pageLoading = false
        this.getInstallState()
      }).catch(() => { this.pageLoading = false })
    },
    scrollHandle(e) {
      this.scrollFunc(e)
    },
    random(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    // 安装函数
    install(version) {
      if (!this.canInstall()) {
        return
      }
      const id = this.plugin.id
      const name = this.plugin.name
      const author = this.plugin.author.nickname
      const url = version.match[0]
      const code = version.code
      const pluginCrypto = new PluginCrypto()
      const addon_json = pluginCrypto.encode({ id, name, author, url, code })
      if (this.installState === 'install') {
        // 安装插件
        try {
          window.via.addon(addon_json)
          window.localStorage.setItem(`plugin_${id}`, version.id)
          this.addInstallCount()
        } catch (err) {
          this.$toast.fail(`安装失败${err}`)
        }
        this.$toast.success('安装成功')
      } else if (this.installState === 'update') {
        // 更新插件
        try {
          window.via.addon(addon_json)
          window.via.addon(addon_json)
          window.localStorage.setItem(`plugin_${id}`, version.id)
          this.addInstallCount()
        } catch (err) {
          this.$toast.fail(`更新失败${err}`)
        }
        this.$toast.success('已更新')
      } else if (this.installState === 'uninstall') {
        // 卸载插件
        try {
          window.via.addon(addon_json)
          window.localStorage.removeItem(`plugin_${id}`)
        } catch (err) {
          this.$toast.fail(`卸载失败${err}`)
        }
        this.$toast.success('已卸载')
      }
      this.getInstallState()
    },
    // 判断是否是via
    canInstall() {
      if (window.via && typeof window.via.addon === 'function') {
        return true
      }
      this.$toast.fail('你的浏览器不支持安装插件')
      return false
    },
    // 获取安装状态
    getInstallState() {
      let state = 'install'
      if (window.via && typeof window.via.getInstalledAddonID === 'function') {
        // 获取已安装的数组
        const intallIds = JSON.parse(window.via.getInstalledAddonID())
        intallIds.forEach(installId => {
          if (Number(installId) === Number(this.plugin.id)) {
            state = 'uninstall'
            const versionId = window.localStorage.getItem(`plugin_${installId}`) || Number.MAX_VALUE
            const lastVersionId = this.lastVersion.id
            if (Number(versionId) < Number(lastVersionId)) {
              state = 'update'
            }
          }
        })
      }
      this.installState = state
    },
    // 判断插件状态，审核还没通过的只能让开发者和管理员看
    canRead(authorId, reviewState) {
      const userInfo = this.$store.getters['globalData/userInfo']
      const userType = userInfo.type || ''
      if (reviewState !== Review.Agree) {
        // 管理员和站长可以看
        if ([UserType.StationMaster, UserType.Admin].indexOf(userType) >= 0) {
          return true
        }
        // 开发者本人可以看
        if (String(userInfo.id) === String(authorId)) {
          return true
        }
        return false
      }
      return true
    },
    // 菜单回调
    menuSelectHandle(e) {
      switch (e.code) {
        case 'visitAuthor':
          this.goToAuthorPage()
          break
        case 'historyVersion':
          this.showMenu = false
          this.showHistoryVersion = true
          break
        case 'concatAuthor':
          this.sendEmailToAuthor()
          break
        case 'reportPlugin':
          this.sendEmailToPluginSite()
          break
        default:
          break
      }
      this.showMenu = false
    },
    // 发邮件给作者
    sendEmailToAuthor() {
      const subject = 'via插件：来自用户的邮件'
      const body = `你好，我是via插件网的用户，对于你的插件：${this.plugin.name}。我想提点建议：`
      const from = 'via_plugin@163.com'
      const to = this.plugin.author.email
      window.location = `
        mailto:${to}?cc=${from}&subject=${subject}&body=${body}
      `
    },
    // 举报, 发邮件给本网站
    sendEmailToPluginSite() {
      const subject = 'via插件举报：来自用户的邮件'
      const body = `你好，我是via插件网的用户，我想举报一个插件。插件名字：${this.plugin.name}，举报原因：`
      const from = 'via_plugin@163.com'
      const to = `2214962083@qq.com`
      window.location = `
        mailto:${to}?cc=${from}&subject=${subject}&body=${body}
      `
    },
    // 去作者主页
    goToAuthorPage() {
      this.$router.$push({
        name: 'User',
        params: {
          id: this.plugin.author.id
        }
      })
    },
    // 统计安装次数
    addInstallCount() {
      // 现在
      const now = new Date().getTime()
      // 上次保存的时间
      const lastTime = Number(window.localStorage.getItem('installArrySaveTime')) || 0
      // 限制时间
      const limitTime = 24 * 60 * 60 * 1000

      if (now - lastTime >= limitTime) {
        window.localStorage.setItem('installArray', JSON.stringify([]))
        window.localStorage.setItem('installArrySaveTime', now)
      }

      // 某段时间内安装的插件数组
      const pluginIds = JSON.parse(window.localStorage.getItem('installArray')) || []
      // 本插件id
      const pluginId = this.$route.params.id
      if (pluginIds.indexOf(pluginId) >= 0) {
        return
      }
      pluginIds.push(pluginId)
      window.localStorage.setItem('installArray', JSON.stringify(pluginIds))
      this.$api.plugin.addInstallation(this.$route.params.id)
    }
  }
}
</script>

<style scoped>
.nav_2 {
  width: 375px;
  height: 46px;
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  -webkit-backdrop-filter: brightness(150%) blur(5px);
  backdrop-filter: brightness(150%) blur(5px);
  background-color: rgba(255, 255, 255, 0.3);
}
.nav-title {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.page {
  width: 375px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.page-top-blank {
  width: 375px;
  height: 46px;
}
.page-top {
  position: relative;
  width: 375px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.page-top .van-skeleton__avatar {
  margin: 15px 15px 15px 0;
  border-radius: 15px;
}

/* 插件名字、图标、作者 */
.plugin-info-top {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 20px 15px;
}
.plugin-info-top-left {
  width: 80px;
  margin-right: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.plugin-info-top-right {
  position: relative;
  width: 250px;
  height: 80px;
  display: flex;
  flex-direction: column;
}
.plugin-info-top-right > .plugin-name {
  font-weight: 900;
  color: var(--light20);
  font-size: 16px;
}
.plugin-info-top-right > .plugin-author {
  margin-top: 4px;
  color: var(--light60);
  font-size: 14px;
}
.plugin-install-btn {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  font-size: 15px;
}

/* 页面底部 */
.page-bottom {
  width: 375px;
  display: flex;
  flex-direction: column;
  background-color: var(--light100);
}

/* 插件其他信息 */

.plugin-info-title {
  width: 100%;
  height: 46px;
  line-height: 46px;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 15px;
  font-weight: 900;
  background-color: var(--light90);
  color: var(--light40);
}
.plugin-info-bottom {
  width: 375px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  padding: 15px;
}
.plugin-info-bottom > .row {
  display: flex;
  width: 100%;
  margin-bottom: 15px;
}
.plugin-info-bottom > .row > .sub-title {
  color: var(--light40);
  font-weight: 900;
  font-size: 13px;
  line-height: 20px;
  box-sizing: border-box;
  display: flex;
  width: 40px;
}
.plugin-info-bottom > .row > .sub-content {
  color: var(--light40);
  font-size: 13px;
  line-height: 20px;
  width: 305px;
}

/* 插件说明文档 */
.page-bottom-title {
  width: 100%;
  height: 46px;
  line-height: 46px;
  box-sizing: border-box;
  padding: 0 15px;
  font-size: 15px;
  font-weight: 900;
  background-color: var(--light90);
  color: var(--light40);
}
.md {
  z-index: auto !important;
  min-height: 0;
}

/* 历史版本相关 */
.version-box {
  width: 375px;
  display: flex;
  flex-direction: column;
  padding: 15px 60px 15px 15px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--light90);
  position: relative;
}
.version-box > .row {
  font-size: 13px;
}
.version-box > .version-update-time {
  margin: 6px 0;
}
.version-box-intsall-btn {
  width: 30px;
  height: 30px;
  line-height: 30px;
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 15px;
}
</style>
<style>
@import '../../static/css/markdown-theme-pink.css';
.page-middle .van-skeleton__avatar--square {
  border-radius: 15px;
}
</style>
